export default __webpack_public_path__ + "static/media/google-icon.66ae25be.svg";